import React, { useState, useRef, useEffect } from 'react';
const FilterOption = ({ icon, label, active = false, count = null, options = [] }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(label);
    const dropdownRef = useRef(null);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
    };
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (React.createElement("div", { className: "relative w-full", ref: dropdownRef },
        React.createElement("button", { onClick: toggleDropdown, className: `flex items-center justify-between w-full px-3 py-2 text-sm font-medium ${active
                ? 'bg-blue-50 text-blue-700 border border-blue-300'
                : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'} rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500` },
            React.createElement("div", { className: "flex items-center" },
                icon && React.createElement("span", { className: "mr-2 flex-shrink-0" }, icon),
                React.createElement("span", { className: "truncate" }, selectedOption),
                count !== null && (React.createElement("span", { className: "ml-1.5 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" }, count))),
            React.createElement("svg", { className: `ml-2 h-5 w-5 flex-shrink-0 ${active ? 'text-blue-500' : 'text-gray-400'}`, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor" },
                React.createElement("path", { fillRule: "evenodd", d: isOpen
                        ? "M14.77 12.79a.75.75 0 01-1.06-.02L10 8.832 6.29 12.77a.75.75 0 11-1.08-1.04l4.25-4.5a.75.75 0 011.08 0l4.25 4.5a.75.75 0 01-.02 1.06z"
                        : "M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z", clipRule: "evenodd" }))),
        isOpen && options.length > 0 && (React.createElement("div", { className: "absolute left-0 z-10 mt-1 w-full bg-white rounded-md shadow-lg py-1 border border-gray-200 animate-fadeIn" }, options.map((option, index) => (React.createElement("div", { key: index, className: `px-3 py-2 text-sm cursor-pointer flex items-center ${option === selectedOption
                ? 'bg-blue-50 text-blue-700'
                : 'text-gray-700 hover:bg-gray-50'}`, onClick: () => handleOptionSelect(option) },
            option === selectedOption && (React.createElement("svg", { className: "h-4 w-4 text-blue-500 mr-2", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor" },
                React.createElement("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" }))),
            React.createElement("span", { className: option === selectedOption ? 'font-medium' : '' }, option))))))));
};
export default FilterOption;
